import { render, staticRenderFns } from "./r-worker-team-dropdown.vue?vue&type=template&id=2d621dda"
import script from "./r-worker-team-dropdown.vue?vue&type=script&lang=js"
export * from "./r-worker-team-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d621dda')) {
      api.createRecord('2d621dda', component.options)
    } else {
      api.reload('2d621dda', component.options)
    }
    module.hot.accept("./r-worker-team-dropdown.vue?vue&type=template&id=2d621dda", function () {
      api.rerender('2d621dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-worker-team-dropdown.vue"
export default component.exports